import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import SideMenu from "./SideMenu";
import { useTheme } from "../ThemeContext"; // Import your ThemeContext
import Chat from './Chat/Chat';
function Layout() {
  const { theme } = useTheme(); // Get the current theme
  //console.log(theme);
  const currentYear = new Date().getFullYear();
  // Define classes based on the current theme
  const headerClass = theme === 'light' ? 'bg-white text-gray-200' : 'bg-gray-800 text-white';
  const mainClass = theme === 'light' ? 'bg-slate-300 text-gray-800' : 'bg-gray-900 text-white';
  const footerClass = theme === 'light' ? 'bg-slate-300 text-gray-600' : 'bg-gray-900 text-gray-100'; // Footer styles based on theme

  return (
    <>
      {/* Wrapper to ensure footer sticks at bottom */}
      <div className="flex flex-col min-h-screen">
        <div className={`md:h-16 ${headerClass}`}>
          <Header />
        </div>
        <div className={`grid grid-cols-12 flex-grow ${mainClass}`}>
          <div className="col-span-2 h-screen sticky top-5 hidden lg:flex">
            <SideMenu />
          </div>
          <div className={`col-span-10 pt-4 pl-4 pb-0 max-h-full`}>
            <Outlet />
           {/* <Chat />*/}
          </div>

        </div>
        <footer className={` text-center ${footerClass}  p-1 w-full bottom-0`}>
          <p className="text-sm">
            &copy; {currentYear} Powered by{' '}
            <a
              href="https://www.techcryptors.services/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Tech Cryptors Private Limited (TCIS)
            </a>
          </p>
        </footer>
      </div>


    </>
  );
}

export default Layout;
